export default [
  {
    path: '/minha-conta',
    name: 'minhaConta',
    component: () => import(/* webpackChunkName: "minhaConta" */ '../../views/minhaConta/MinhaConta')
  }
]
